

class QuantityStepper extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector(".quantity-stepper__input");
    this.decreaseButton = this.querySelector("[data-decrease]");
    this.increaseButton = this.querySelector("[data-increase]");

    if (!this.input) return;

    this.decreaseButton?.addEventListener("click", () => this._step(-1));
    this.increaseButton?.addEventListener("click", () => this._step(1));
    this.input.addEventListener("change", () => this._clamp());
  }

  get min() {
    const min = parseInt(this.dataset.min, 10);
    return Number.isNaN(min) ? 1 : min;
  }

  get max() {
    const max = parseInt(this.dataset.max, 10);
    return Number.isNaN(max) ? Infinity : max;
  }

  _clamp() {
    const value = parseInt(this.input.value, 10);

    if (Number.isNaN(value) || value < this.min) {
      this.input.value = this.min;
      return;
    }

    if (value > this.max) {
      this.input.value = this.max;
      this._notifyMax();
    }
  }

  _step(delta) {
    const current = parseInt(this.input.value, 10) || this.min;
    const next = current + delta;

    if (next < this.min) return;

    if (next > this.max) {
      this._notifyMax();
      return;
    }

    this.input.value = next;
    this.input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  _notifyMax() {
    if (typeof window.showToast !== "function") return;

    const message = this.dataset.maxMessage || `You can only have ${this.max} of this item in your cart.`;

    window.showToast(message);
  }
}

if (!customElements.get("quantity-stepper")) {
  customElements.define("quantity-stepper", QuantityStepper);
}
